import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export default firebase;
